import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../ArticleComponents.module.css';

import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

export default function DoubleAdvertComponent({
	component,
	readerMode,
	onImageClick,
	onScaleChange,
}) {
	const { images } = component;
	const [scale, setScale] = useState(1);
	const [position, setPosition] = useState({ x: 0, y: 0 });
	const containerStyle = {
		width: '100%',
		/*maxWidth: '1024px',
		maxHeight: '90vh',
		maxHeight: '90vh',*/
		background: 'red',
	};
	if (readerMode) {
		containerStyle.height = 0;
	}

	const onClick = () => onImageClick(component);

	const step = 0.2;
	const maxZoom = 3;

	const zoomIn = () => {
		const newScale = step + scale;
		if (onScaleChange) {
			onScaleChange(newScale);
		}
		setScale(newScale);
	};

	const zoomOut = () => {
		if (scale !== 1) {
			const newScale = scale - step > 1 ? scale - step : 1;

			if (newScale === 1) {
				if (onScaleChange) {
					onScaleChange(1);
					setPosition({
						x: 0,
						y: 0,
					});
				}
			}
			setScale(newScale);
		}
	};

	return (
		<div className={styles['component-double-advert-container']}>
			<div
				onClick={() => {
					if (scale === 1) {
						onClick();
					}
				}}
			>
				<TransformWrapper
					defaultScale={1}
					scale={scale}
					defaultPositionX={0}
					defaultPositionY={0}
					pan={{
						disabled: scale <= 1,
					}}
					positionX={position.x}
					positionY={position.y}
					wheel={{ disabled: false }}
					pinch={{ disabled: false }}
					onPinching={(e) => {
						const { positionX, positionY } = e;
						if (onScaleChange) {
							setScale(e.scale);
							onScaleChange(e.scale);
							setPosition({
								x: positionX,
								y: positionY,
							});
						}
					}}
					onPinchingStop={(e) => {
						if (e.scale < 1) {
							setScale(1);
							onScaleChange(1);
							setPosition({
								x: 0,
								y: 0,
							});
						}
					}}
					doubleClick={{ disabled: true }}
				>
					<TransformComponent>
						<div
							className={styles['component-double-advert-image']}
						>
							<div>
								<img src={images[0]} alt={'Advert'} />
							</div>
							<div>
								<img src={images[1]} alt={'Advert'} />
							</div>
						</div>
					</TransformComponent>
				</TransformWrapper>
			</div>
			<div className={styles['buttons-container']}>
				{scale < maxZoom ? (
					<button onClick={zoomIn} className={styles['zoom-in']}>
						<div />
					</button>
				) : (
					<button disabled className={styles['zoom-in']}>
						<div />
					</button>
				)}

				{scale === 1 ? (
					<button disabled className={styles['zoom-out']}>
						<div />
					</button>
				) : (
					<button onClick={zoomOut} className={styles['zoom-out']}>
						<div />
					</button>
				)}
			</div>
		</div>
	);
}

DoubleAdvertComponent.propTypes = {
	component: PropTypes.object.isRequired,
	readerMode: PropTypes.bool,
	onImageClick: PropTypes.func,
	onScaleChange: PropTypes.func,
};